module.exports = __webpack_public_path__ + "img/undraw_Search_1px8.57ee51ae.svg";